// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"391":"6e547a78","739":"b49c7f36","748":"4d4f0e8e","753":"5fdcc043","820":"b49c7f36"}[chunkId] + ".chunk.css";
};